var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { sortColumnConfig } from '../columns/sort';
export const prepareColumnsConfig = (columnsConfig, { isRowsSortable, isMobile, } = {}) => {
    const columns = columnsConfig.map((column) => {
        var _a;
        const { options } = column;
        const _b = options || {}, { isDesktopOnly, isMobileOnly } = _b, restOptions = __rest(_b, ["isDesktopOnly", "isMobileOnly"]);
        const isHidden = (isMobile && isDesktopOnly === true) ||
            (!isMobile && isMobileOnly === true);
        return Object.assign(Object.assign({}, column), { options: Object.assign(Object.assign({}, restOptions), { display: !isHidden ? 'true' : 'excluded', sort: typeof ((_a = column.options) === null || _a === void 0 ? void 0 : _a.sort) !== 'undefined'
                    ? column.options.sort
                    : false }) });
    });
    if (isRowsSortable) {
        columns.unshift(sortColumnConfig);
    }
    return columns;
};
